import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

const StickyCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      aria-hidden={!visible}
      className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-40 transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <div className="flex items-center gap-3 rounded-full border border-border bg-background/95 backdrop-blur-md shadow-elevation-4 pl-4 pr-1.5 py-1.5">
        <span className="hidden sm:inline-flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
          <Sparkles className="h-3.5 w-3.5 text-accent-strong" />
          Free plan • No card required
        </span>
        <Link to="/signup">
          <Button variant="hero" size="sm" className="rounded-full px-5">
            Start free
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default StickyCta;
